import { classNames } from "primereact/utils";

import { useKanbanContext } from "../kanban.context";
import styles from "../kanban.module.scss";
import type { KanbanCardProps } from "../types-kanban";

/** Moldura do card (fundo, raio e padding do Figma); o corpo é da tela, por `children`. */
export function KanbanCard({ children, className, ...rest }: KanbanCardProps) {
  useKanbanContext();

  return (
    <article className={classNames(styles.card, className)} {...rest}>
      {children}
    </article>
  );
}
KanbanCard.displayName = "Kanban.Card";
